'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Styles = require("../styles");
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header(props) {
        var _this = _super.call(this, props) || this;
        _this.intervalId = null;
        _this.state = { timer: 0 };
        return _this;
    }
    Header.prototype.componentDidMount = function () {
        var _this = this;
        this.intervalId = global.setInterval(function () {
            _this.setState(function (prevState) {
                return ({ timer: prevState.timer + 1 });
            });
        }, 1000);
    };
    Header.prototype.componentWillUnmount = function () {
        if (this.intervalId) {
            global.clearInterval(this.intervalId);
        }
    };
    Header.prototype.render = function () {
        if (this.props.gameEnded && this.intervalId) {
            global.clearInterval(this.intervalId);
        }
        var timer = this.state.timer;
        var timerMinutes = ("" + Math.floor(timer / 60)).padStart(2, '0');
        var timerSeconds = ("" + timer % 60).padStart(2, '0');
        return (React.createElement("div", { id: 'header', style: Styles.header },
            React.createElement("div", { id: 'game-timer', style: Styles.headerTimer },
                React.createElement("img", { src: '/img/timer.png', style: Styles.headerTimerImg, alt: 'game timer' }), timerMinutes + ":" + timerSeconds),
            React.createElement("div", { id: 'mines-left', style: Styles.headerMines },
                React.createElement("img", { src: '/img/mine.png', style: Styles.headerMinesImg, alt: 'mines left' }),
                this.props.minesLeft),
            React.createElement("div", { id: 'lives', style: Styles.headerLives },
                React.createElement("img", { src: '/img/lives.png', style: Styles.headerLivesImg, alt: 'lives left' }),
                this.props.lives)));
    };
    return Header;
}(React.Component));
exports.Header = Header;
//# sourceMappingURL=Header.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/components/Header.js
// module id = 35
// module chunks = 0